module.exports = __webpack_public_path__ + "img/fron-02.3111ed8c.jpg";